<div class="dialog-box">
  <div class="dialog-box__header">
    <button mat-icon-button (click)="cancel()" tabindex="-1">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="dialog-box__content confirmation-content">
    <h1>{{ "ONFIDO.RESET_DIALOG.TITLE" | translate }}</h1>
    <p>{{ "ONFIDO.RESET_DIALOG.MESSAGE" | translate }}</p>
    <p>{{ "ONFIDO.RESET_DIALOG.REMAINING_ATTEMPTS" | translate: { count: data.resetsRemaining } }}</p>
    <div class="confirmation-actions">
      <button class="btn btn--secondary btn--longer" type="button" (click)="cancel()">
        {{ "COMMON.CANCEL" | translate }}
      </button>
      <button class="btn btn--primary btn--longer" type="button" (click)="startOver()">
        {{ "ONFIDO.RESET_DIALOG.START_OVER" | translate }}
      </button>
    </div>
  </div>
</div>
